import { ManhattanOneContractorSyncSummary } from './service.connection';

// A Running contractor sync that has not reported progress for this long is treated as dead
// (the API process was restarted mid-run) — another run may be started and the UI stops waiting
export const MANHATTAN_ONE_SYNC_STALE_MS = 10 * 60 * 1000;

/** The time the run last reported anything */
export function manhattanOneSyncLastProgress(summary: ManhattanOneContractorSyncSummary): Date {

    return new Date(summary.updatedAt ?? summary.startedAt);
}

/** True while a run is marked Running and has reported progress recently enough to be believed */
export function isManhattanOneSyncInProgress(summary: ManhattanOneContractorSyncSummary | null | undefined, now = Date.now()): boolean {

    if (summary?.status !== 'Running') return false;
    return now - manhattanOneSyncLastProgress(summary).getTime() < MANHATTAN_ONE_SYNC_STALE_MS;
}

/** True for a run that is still marked Running but has gone quiet — it will not finish */
export function isManhattanOneSyncStale(summary: ManhattanOneContractorSyncSummary | null | undefined, now = Date.now()): boolean {

    return summary?.status === 'Running' && !isManhattanOneSyncInProgress(summary, now);
}

/** Suppliers dealt with so far (each one is created, updated, unchanged or failed) */
export function manhattanOneSyncProcessed(summary: ManhattanOneContractorSyncSummary): number {

    return summary.created + summary.updated + summary.unchanged + summary.failed;
}
